import config from "config/config";
import { ThemeProvider } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";
import React, { useEffect } from "react";
// Material Dashboard 2 React themes
import theme from "assets/theme";

// Material Dashboard 2 React Dark Mode themes
import themeDark from "assets/theme-dark";
import { useAuth } from "context";
import { Outlet } from "react-router-dom";
import { setupAxios } from "./core/AuthHelper";
import MDSnackbar from "components/MDSnackbar";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import { OtpProvider } from "context/OtpContext";
import axios from "axios";
import { ErrorBoundary } from "./bugsnagConfig";

import TagManager from "react-gtm-module";

const App = () => {
  const envConfig = config[process.env.REACT_APP_ENV?.toUpperCase() || "LOCAL"];
  const gtmId = envConfig.GTM_ID;
  const { darkMode, logout, snackbarMessage, showSnackbar, saveAuthData } = useAuth();

  useEffect(() => {
    if (gtmId) {
      TagManager.initialize({ gtmId });
    }
    setupAxios(axios, saveAuthData, logout);
  }, []);

  useEffect(() => {
    const { WIDGET_LOADER_URL, WIDGET_PARTNER_KEY } = envConfig;
    if (!WIDGET_LOADER_URL || !WIDGET_PARTNER_KEY) return;
    const script = document.createElement("script");
    script.src = WIDGET_LOADER_URL;
    script.async = true;
    script.setAttribute("data-cr-partner-key", WIDGET_PARTNER_KEY);
    script.setAttribute("data-cr-position", "bottom-right");
    document.head.appendChild(script);
  }, []);

  return (
    <ErrorBoundary>
      <ThemeProvider theme={darkMode ? themeDark : theme}>
        {!!snackbarMessage.type && (
          <MDSnackbar
            color={snackbarMessage.type === "error" ? "error" : "success"}
            icon={snackbarMessage.type === "error" ? <ErrorOutlineIcon fontSize="small" /> : <CheckCircleOutlineIcon fontSize="small" />}
            title={snackbarMessage.type === "error" ? "Error" : "Success"}
            content={snackbarMessage.message}
            open={showSnackbar}
            bgWhite
          />
        )}
        <CssBaseline />
        <OtpProvider length={6}>
          <Outlet />
        </OtpProvider>
        {/* GTM noscript fallback */}
        {gtmId && (
          <div
            dangerouslySetInnerHTML={{
              __html: `<noscript><iframe src="https://www.googletagmanager.com/ns.html?id=${gtmId}"
              height="0" width="0" style="display:none;visibility:hidden"></iframe></noscript>`,
            }}
          />
        )}
      </ThemeProvider>
    </ErrorBoundary>
  );
};

export default App;
